export default "__VITE_ASSET__B6b3BnST__"